import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../types/state/storeTypes';
import { SurveyNotificationProps } from '../../types/components/user-survey/UserSurveyNotification';
import userHelpers from '../../helpers/user';

import { ExitIcon } from '../../modules/Icons';
import ProgressBar from '../shared/ProgressBar';

const SurveyNotification: React.FC<SurveyNotificationProps> = ({
  user,
  onComplete,
}) => {
  const [visible, setVisible] = useState(false);
  const hasCompletedSurvey = userHelpers.userHasCompletedSurvey(user);

  const onDismiss = () => setVisible(false)

  useEffect(() => {
    if (!hasCompletedSurvey) {
      const oneMinute = 60000;

      const minMinutes = 10;
      const maxMinutes = 60;
      const randomMinutes = Math.random() * (maxMinutes - minMinutes) + minMinutes;
      const randomTime = Math.floor(randomMinutes * oneMinute);

      const showTimer = setTimeout(() => {
        setVisible(true);

        // Auto-hide after 15 seconds
        const hideTime = 15000;

        const hideTimer = setTimeout(() => {
          onDismiss();
        }, hideTime);

        return () => clearTimeout(hideTimer);

      }, randomTime);

      return () => {
        clearTimeout(showTimer);
      };
    }
  }, [hasCompletedSurvey]);

  if (!visible || hasCompletedSurvey) return null;

  return (
    <div cy-test-id="user-survey-notification" className="fixed z-50 bottom-1 right-1 lg:bottom-4 lg:right-4 animate-slide-up">
      <div className="bg-[#15191B] rounded-[5px] shadow-lg overflow-hidden px-4 py-4 md:px-6 md:py-4">
        <div className="items-center justify-between w-full md:flex">

          <div className='flex items-start gap-2'>


            <div className="flex-1 md:mr-[43px]">
              <h3 className="font-bold text-white text-16 inter leading-24">Your profile is almost complete!</h3>
              <ProgressBar className={"bg-a-blue animate-pulse"} bgColor={"bg-[#24C1FF] bg-opacity-30"} progressPct={80} />
            </div>
            <button
              onClick={() => onDismiss()}
              className="md:hidden"
            >
              <ExitIcon className="w-6" />
            </button>

          </div>

          <button
            onClick={() => {
              setVisible(false);
              onComplete();
            }}
            className="bg-[#00A1E0] hover:bg-[#24C1FF] text-white font-medium py-2 px-6 rounded-lg transition-colors flex-shrink-0"
          >
            Complete
          </button>

          <button
            onClick={() => {
              setVisible(false);
              onDismiss();
            }}
            className="hidden ml-4 md:flex md:flex-shrink-0"
          >
            <ExitIcon className="w-6" />
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(SurveyNotification);

